import React from "react";
import { Minus, Plus } from "lucide-react";
import { fmtEUR } from "./euros";

// Raccourcis proposés sous le compteur.
const QUANTITES_PROPOSEES = [1, 3, 5, 10];

/**
 * Choix du nombre d'unités offertes (paniers, repas…) : compteur − / +
 * (minimum 1), raccourcis 1-3-5-10 et total. Le parent calcule `total`
 * (prix unitaire × nombre) : ce composant ne fait qu'afficher.
 *
 * Sorti tel quel de la page campagne pour servir aussi à la future story.
 */
export default function ChoixUnites({ campaign, unitCount, setUnitCount, total }) {
  const price = campaign.unit_price || 0;
  const label = campaign.unit_label || "unité";
  return (
    <div>
      <p className="text-[10px] uppercase tracking-[0.15em] text-stone-500 mb-3">
        Combien souhaitez-vous offrir ?
      </p>
      <div className="flex items-center justify-center gap-4 mb-3 bg-stone-50 rounded-2xl p-5">
        <button type="button"
          onClick={() => setUnitCount(Math.max(1, unitCount - 1))}
          className="trm-cible-tactile h-10 w-10 rounded-full bg-white border border-stone-200 flex items-center justify-center hover:border-stone-400 transition-colors">
          <Minus className="h-4 w-4" />
        </button>
        <div className="text-center min-w-[100px]">
          <p className="text-3xl font-semibold tabular-nums">{unitCount}</p>
          <p className="text-xs text-stone-500">{label}{unitCount > 1 ? "s" : ""}</p>
        </div>
        <button type="button"
          onClick={() => setUnitCount(unitCount + 1)}
          className="trm-cible-tactile h-10 w-10 rounded-full bg-white border border-stone-200 flex items-center justify-center hover:border-stone-400 transition-colors">
          <Plus className="h-4 w-4" />
        </button>
      </div>
      <div className="flex flex-wrap gap-2 mb-3 justify-center">
        {QUANTITES_PROPOSEES.map((s) => (
          <button key={s} type="button" onClick={() => setUnitCount(s)}
            className={`trm-cible-tactile px-3 h-7 rounded-full text-xs font-medium transition-colors ${
              unitCount === s
                ? "bg-stone-900 text-white"
                : "bg-stone-50 text-stone-600 hover:bg-stone-100"
            }`}>
            {s} {label}{s > 1 ? "s" : ""}
          </button>
        ))}
      </div>
      <div className="text-center pt-2 border-t border-stone-100">
        <p className="text-xs text-stone-400">Prix par {label}: {fmtEUR(price)}</p>
        <p className="text-lg font-semibold text-stone-900 mt-1">Total : {fmtEUR(total)}</p>
      </div>
    </div>
  );
}
